/* screens/auth/VerifyEmailChange.jsx — Подтверждение смены email (S12, /verify-email-change?uid&token).
   Доступен всем (бэк AllowAny: наличие валидного токена + pending_email = авторизация на смену).
   При успехе и наличии user → refreshUser(). Кнопки адаптивны к состоянию авторизации.
   Бэк ждёт только {uid, token} (новый адрес лежит в pending_email на сервере; параметр newEmail
   из URL адаптер игнорирует). Невалидный/устаревший токен → 400 code='invalid_token' (catch → error).
   Данные через authReal (adapters/auth.js → profile.confirmEmailChange). */

import React from 'react';
import { useAuth } from '../../app/providers/AuthProvider.jsx';
import { Button } from '../../components/ui/Button.jsx';
import { Icon } from '../../components/ui/Icon.jsx';
import { ScreenHeader } from '../../components/ui/Metric.jsx';
import { Spinner } from '../../components/ui/Spinner.jsx';
import { authReal } from '../../lib/adapters/auth.js';
import { RR } from '../../lib/router.jsx';

  const { useState, useEffect } = React;
  const { useNavigate, useSearchParams } = RR;

  function VerifyEmailChange() {
    const navigate = useNavigate();
    const { user, refreshUser } = useAuth();
    const [sp] = useSearchParams();
    const [phase, setPhase] = useState('loading'); // loading | ok | error
    const authed = !!user;

    useEffect(() => {
      let alive = true;
      authReal.confirmEmailChange({ uid: sp.get('uid'), token: sp.get('token') })
        .then(() => { if (!alive) return; if (user && refreshUser) refreshUser(); setPhase('ok'); })
        .catch(() => { if (alive) setPhase('error'); });
      return () => { alive = false; };
    }, []);

    if (phase === 'loading') {
      return (
        <div className="auth-form auth-status stack stack-12" aria-busy="true">
          <Spinner size="lg" />
          <ScreenHeader align="center" title="Обновляем адрес…" subtitle="Подтверждаем новый email." />
        </div>
      );
    }

    if (phase === 'error') {
      return (
        <div className="auth-form auth-status stack stack-16">
          <div className="auth-status__glyph auth-status__glyph--bad" aria-hidden="true"><Icon name="alert-circle" size={30} /></div>
          <ScreenHeader align="center" title="Не удалось сменить email"
            subtitle="Ссылка недействительна или устарела. Запросите смену email заново." />
          {authed
            ? <Button variant="primary" size="lg" className="full" onClick={() => navigate('/settings?tab=profile')}>Открыть настройки</Button>
            : <Button variant="primary" size="lg" className="full" onClick={() => navigate('/signin')}>Перейти ко входу</Button>}
        </div>
      );
    }

    return (
      <div className="auth-form auth-status stack stack-16">
        <div className="auth-status__glyph auth-status__glyph--ok" aria-hidden="true"><Icon name="check-circle" size={30} /></div>
        <ScreenHeader align="center" title="Email обновлён." subtitle="Новый адрес теперь используется для входа и уведомлений." />
        {authed
          ? <Button variant="primary" size="lg" className="full" onClick={() => navigate('/chat')}>В рабочее пространство</Button>
          : <Button variant="primary" size="lg" className="full" onClick={() => navigate('/signin')}>Войти</Button>}
      </div>
    );
  }

export { VerifyEmailChange };
